export enum FontValues {
    default = `'Inter', Arial, sans-serif`,
    limitless = `'Limitless Sans',sans-serif`,
}

export type ValidatorFunction<T> = (
    value?: T
) => { isValid: boolean; message?: string };
